import MessageCard from './MessageCard';

export default MessageCard;


// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/message-history/message-card/index.js